import FacilityDetailsForm from "./FacilityDetailsForm"

export default FacilityDetailsForm